import IconContainer from '@/components/IconContainer'

export default function IconCopy(props) {
  return (
    <IconContainer
      {...props}
      width="16"
      height="16"
      ariaLabel="Copy Icon"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    >
      <path d="M14.4171 1H4.40857C4.08571 1 3.82571 1.26 3.82571 1.58286V3.30571H1.58286C1.26 3.30571 1 3.56571 1 3.88857V14.4171C1 14.74 1.26 15 1.58286 15H11.5914C11.9143 15 12.1743 14.74 12.1743 14.4171V12.6943H14.4171C14.74 12.6943 15 12.4343 15 12.1114V1.58286C15 1.26 14.7371 1 14.4171 1ZM11.006 13.8344H2.16602V4.47156H11.006V13.8344ZM12.1711 11.5289H13.8283V2.16602H4.98828V3.30602H11.5883C11.9111 3.30602 12.1711 3.56602 12.1711 3.88887V11.5289ZM4.13461 8.25483H8.64033C8.96319 8.25483 9.22319 7.99483 9.22319 7.67197C9.22319 7.34911 8.96319 7.08911 8.64033 7.08911H4.13461C3.81176 7.08911 3.55176 7.34911 3.55176 7.67197C3.55176 7.99483 3.81176 8.25483 4.13461 8.25483ZM8.64033 11.5258H4.13461C3.81176 11.5258 3.55176 11.263 3.55176 10.943C3.55176 10.6201 3.81176 10.3601 4.13461 10.3601H8.64033C8.96319 10.3601 9.22319 10.6201 9.22319 10.943C9.22319 11.2658 8.96319 11.5258 8.64033 11.5258Z" />
    </IconContainer>
  )
}
